import { FormattedMessage, useIntl } from "react-intl"
import { RELATION_TYPE } from "../../../services/objects"
import { LogicRefrerence } from "../../components/LogicReference/LogicReference"
import { IDriveVarSpeed } from './types'
import InsightsPanel from "./InsightsPanel"

export const SideviewPanel = (props: IDriveVarSpeed) => {
     
    const intl = useIntl();
    return (
        <>
        <InsightsPanel {...props}></InsightsPanel>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.InputAutoOpen} enableAdd={true} text={intl.formatMessage({ id: 'Drive.InputAutoOn', defaultMessage: "Reference for the automatic (only for cloud controlled systems)." })}></LogicRefrerence>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.InputAutoOpen} enableAdd={true} text={intl.formatMessage({ id: 'Drive.InputAutoSpeed', defaultMessage: "Reference for the automatic speed (only for cloud controlled systems)." })}></LogicRefrerence>
        
        </>
    )
}